import { Lager_Asteria_Bankingconnection } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type GetBankingConnectionByConnectionIdQueryType = {
  lager_asteria_bankingconnection: Array<
    Pick<Lager_Asteria_Bankingconnection, 'bank' | 'integration'>
  >;
};

export type GetBankingConnectionByConnectionIdQueryVariablesType = {
  connection_id: string;
};

export const getBankingConnectionByConnectionIdQuery = gql`
query getBankingConnectionByConnectionIdQuery($connection_id: String!) {
  lager_asteria_bankingconnection(where: {connection_id: {_eq: $connection_id}}) {
    bank
    integration
  }
}

` as TypedDocumentNode<
  GetBankingConnectionByConnectionIdQueryType,
  GetBankingConnectionByConnectionIdQueryVariablesType
>;
